import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import Slider from "react-slick";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import fullfacebotox from "../../../assets/facebotox.jpg";
import ShareButtons from "../../utility/ShareButtons";
import facebotox from "../../../assets/facebotoxx.jpeg";
import underArm from "../../../assets/underArm.jpg";

import facebotox2 from "../../../assets/fullfacebotox1.jpg";
import facebotox3 from "../../../assets/facebotox3.jpg";
import { CustomNextArrow, CustomPrevArrow } from "../../utility/CustomArrow";
import Testimonials from "../homepage/Testimonials";
import { useGlobalData } from "../../contextApi/globalContextData";
import OurTeam from "../homepage/OurTeam";
import { useCart } from "../../contextApi/cartContext";
import MultiStepForm from "../../utility/serviceTemplateutility/MultiStepForm";
import QuickNavigation from "../../utility/serviceTemplateutility/QuickNavigation";
import WhyUs from "../../utility/serviceTemplateutility/WhyUs";
import Procedures from "../../utility/serviceTemplateutility/Procedures";
import EligibilityForTreatment from "../../utility/serviceTemplateutility/EligibilityForTreatment";
import Benefits from "../../utility/serviceTemplateutility/Benefits";
import CardDesign from "../../utility/serviceTemplateutility/CardDesigntwo";

const ServiceTemplate = () => {
  const [activeTab, setActiveTab] = useState("benefits");
  const [phone, setPhone] = useState("");
  const { sectionsData, loading, error } = useGlobalData();
  const { addToCart } = useCart();

  const product = {
    id: 1,
    title: "Full Face Botox",
    price: 199,
    image: fullfacebotox,
    description:
      "Full Face Botox smooths fine lines and wrinkles by relaxing facial muscles, giving you a youthful, refreshed, and natural look.",
  };

  const [isScrolled, setIsScrolled] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedDate, setSelectedDate] = useState();
  const [selectedTime, setSelectedTime] = useState();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const images = [facebotox3, facebotox2, facebotox3, facebotox2];
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 3500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };
  const processSteps = [
    {
      title: "Initial Consultation",
      description:
        "Our medical professionals assess your health needs and recommend the right IV treatment.",
      icon: "fa-user-md",
    },
    {
      title: "Personalized Formula",
      description:
        "We prepare a custom IV drip formula based on your specific health requirements.",
      icon: "fa-flask",
    },
    {
      title: "Comfortable Administration",
      description:
        "Relax in our spa-like environment while our certified nurses administer your IV drip.",
      icon: "fa-hand-holding-medical",
    },
    {
      title: "Immediate Benefits",
      description:
        "Feel the effects immediately as vital nutrients enter your bloodstream directly.",
      icon: "fa-heartbeat",
    },
    {
      title: "Follow-up Care",
      description:
        "We monitor your progress and adjust future treatments for optimal results.",
      icon: "fa-clipboard-check",
    },
  ];
  const benefits = [
    {
      title: "Smooths Fine Lines & Wrinkles",
      description:
        "Regular Botox treatments can prevent the formation of new wrinkles by relaxing the muscles that cause them.",
      icon: "fa-shield-virus",
    },
    {
      title: "Prevents New Wrinkles",
      description:
        "Experience a natural energy boost without the crash associated with caffeine or energy drinks.",
      icon: "fa-bolt",
    },
    {
      title: "Non-Surgical Solution",
      description:
        "Full face Botox provides a non-invasive alternative to surgery with minimal downtime and no recovery period, making it convenient for busy lifestyles.",
      icon: "fa-sync",
    },
    {
      title: "Quick & Long-Lasting Results",
      description:
        "The procedure is fast, typically taking 15-30 minutes, with results that can last up to 4-6 months.",
      icon: "fa-tint",
    },
    {
      title: "Improves Facial Symmetry",
      description:
        "Botox can be used to enhance facial symmetry by balancing muscle activity in different areas of the face, improving overall aesthetics.",
      icon: "fa-recycle",
    },
    {
      title: " Boosts Confidence",
      description:
        "By rejuvenating your facial appearance, full face Botox helps you feel more confident and refreshed.",
      icon: "fa-spa",
    },
  ];

  const eligibleSteps = [
    {
      icon: "fas fa-check",
      title: "Early Signs of Aging",
      desc: "If you're noticing fine lines, crow’s feet, or forehead wrinkles, Botox can help smooth these out for a rejuvenated look.",
    },
    {
      icon: "fas fa-exclamation-triangle",
      title: "Desire for Non-Surgical Solutions",
      desc: "Ideal for those who want a noticeable, yet natural, improvement without the risks or downtime of surgery.",
    },
    {
      icon: "fas fa-smile-beam",
      title: "Looking for Subtle Enhancement",
      desc: "Perfect for anyone who wants to enhance their facial features while maintaining their natural expressions.",
    },
    {
      icon: "fas fa-shield-alt",
      title: "Preventive Treatment",
      desc: "Younger individuals can also benefit from Botox as a preventive measure to delay the onset of wrinkles.",
    },
    {
      icon: "fas fa-user-cog",
      title: "Personalized Care",
      desc: "Whether you're focused on the forehead, eyes, or jawline, Full Face Botox can be tailored to your unique needs.",
    },
  ];

  const preparations = [
    {
      title: "Consult with a Professional",
      description:
        "Schedule a consultation to discuss your goals and ensure Botox is right for you.",
      icon: "fa-tint",
    },
    {
      title: "Stay Hydrated",
      description:
        "Refrain from taking aspirin, ibuprofen, or supplements like fish oil a week before your appointment to reduce the risk of bruising.",
      icon: "fa-utensils",
    },
    {
      title: "Skip Alcohol",
      description:
        "Avoid alcohol consumption at least 24 hours before your appointment to minimize swelling.",
      icon: "fa-clipboard-list",
    },
    {
      title: "Arrive with Clean Skin",
      description:
        "On the day of your treatment, come with a fresh face, free of makeup or lotions.",
      icon: "fa-clipboard-list",
    },
  ];

  return (
    <div className="min-vh-100 font-sans text-dark mb-5 mx-3 ">
      {/* Hero Section */}

      <section className="overflow-hidden ">
        <div className="position-relative mb-3">
          <img
            src={fullfacebotox}
            alt="Immune Booster IV Treatment "
            className="img-fluid w-100 rounded mt-2 "
            style={{
              height: "500px",
              objectFit: "cover",
              objectPosition: "top",
              border: "2px solid #c69933",
              borderRadius: "100px",
            }}
          />
        </div>
      </section>

      <div className="d-flex gap-4  w-100 ">
        <div
          className=" rounded-4 p-1 bg-white flex-grow-1 "
          style={{
            width: "60%",
            border: "2px solid #c69933",
          }}
        >
          {/* Key Benefits Section */}
          <section id="benefits" className="bg-white py-5">
            <div className="container">
              <h1
                className="display-4 fw-bold "
                style={{
                  color: "#c69933",
                }}
              >
                Full Face Botox
              </h1>

              <QuickNavigation />

              <img
                className="img-fluid mx-auto d-block"
                src={facebotox}
                alt="Face Botox"
                style={{ maxWidth: "100%", height: "auto" }}
              />

              <div className="text-center mb-5 mt-4">
                <h2
                  className=" fw-bold mb-2 h1"
                  style={{
                    color: "#c69933",
                  }}
                >
                  Key Benefits
                </h2>
                <h3 className="fw-bold mb-3">
                  Revitalize Your Look with Botox Full Face Treatment: The Key
                  to Timeless Beauty
                </h3>
                <p className="lead mx-auto" style={{ maxWidth: "600px" }}>
                  Botox Full Face Treatment offers a complete facial
                  rejuvenation...
                </p>
              </div>

              <Benefits benefits={benefits} />
            </div>
          </section>

          {/* This section has been moved and redesigned below the Expected Results section */}
          {/* Eligibility Section */}
          <section id="eligibility" className="py-5 bg-white">
            <div className="container">
              <div className="text-center mb-5">
                <h2
                  className="h1 fw-bold mb-3"
                  style={{
                    color: "#c69933",
                  }}
                >
                  Eligibility
                </h2>
                <h3 className="fw-bold mb-4 h3">
                  Who Can Benefit from Full Face Botox? Discover If It’s Right
                  for You
                </h3>
                <p
                  className="text-muted mx-auto"
                  style={{ maxWidth: "768px", fontSize: "1.125rem" }}
                >
                  Full Face Botox is ideal for individuals seeking a
                  non-surgical solution to enhance their appearance, smooth
                  wrinkles, and restore youthful vitality. See if you're a good
                  candidate below.
                </p>
              </div>

              <EligibilityForTreatment eligibleSteps={eligibleSteps} />
            </div>
          </section>

          {/* Treatment Process Timeline */}
          <Procedures processSteps={processSteps} />

          {/* Preparations Section */}
          <section id="preparations" className="bg-white pb-5">
            <div className="container">
              <div className="text-center mb-5">
                <h2
                  className="h1 fw-bold mb-3"
                  style={{
                    color: "#c69933",
                  }}
                >
                  Preparations
                </h2>
                <p
                  className="text-muted mx-auto"
                  style={{ maxWidth: "768px", fontSize: "1.125rem" }}
                >
                  How to prepare for your Full Face Botox session for optimal
                  results.
                </p>
              </div>

              <div className="row g-4">
                {preparations.map((prep, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="bg-white p-3 rounded shadow-sm hover-shadow border transition">
                      <div className="d-flex align-items-center mb-3">
                        <div
                          className="d-flex align-items-center justify-content-center rounded-circle me-3"
                          style={{
                            width: "64px",
                            height: "64px",
                            backgroundColor: "#f9f5e8",
                            color: "#c69933",
                          }}
                        >
                          <i className={`fas ${prep.icon} fs-4`}></i>
                        </div>
                        <h5 className="fw-bold mb-0">{prep.title}</h5>
                      </div>
                      <p className="text-muted">{prep.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Results Section */}
          <section id="results" className="pb-5 bg-white">
            <div className="container">
              <div className="text-center mb-5">
                <h2 className="fw-bold h1 mb-3" style={{ color: "#c69933" }}>
                  Expected Results
                </h2>
                <p
                  className="text-muted mx-auto"
                  style={{ maxWidth: "768px", fontSize: "1.125rem" }}
                >
                  After a full face Botox treatment, most patients are excited
                  to see the transformation in their appearance. The results are
                  often subtle yet powerful, offering a more youthful, refreshed
                  look without drastic changes. Here’s what you can expect in
                  terms of results.
                </p>
              </div>

              <div className="row g-4">
                {[
                  {
                    icon: "fas fa-bolt",
                    title: "Immediate Effects",
                    desc: "Feel refreshed and alert right after treatment due to the direct delivery of nutrients to the bloodstream.",
                  },
                  {
                    icon: "fas fa-shield-virus",
                    title: "Enhanced Immunity",
                    desc: "Notice stronger immunity, quicker recovery from illness, and general wellness improvements over days.",
                  },
                  {
                    icon: "fas fa-chart-line",
                    title: "Long-Term Benefits",
                    desc: "Enjoy sustained energy and immunity gains with consistent treatments lasting 2–4 weeks.",
                  },
                  {
                    icon: "fas fa-user-friends",
                    title: "Individual Variations",
                    desc: "Results vary by lifestyle and health. Our team tailors your treatment plan for best results.",
                  },
                ].map((item, idx) => (
                  <CardDesign
                    icon={item.icon}
                    title={item.title}
                    desc={item.desc}
                    index={idx}
                  />
                ))}
              </div>
            </div>
          </section>

          <section>
            <div className="text-center mb-5">
              <h2
                className="fw-bold h1 mb-3"
                style={{
                  color: "#c69933",
                }}
              >
                Before & After
              </h2>
            </div>
            <div className="container my-5">
              <Slider {...settings}>
                {images.map((src, index) => (
                  <div key={index}>
                    <img
                      src={src}
                      alt={`Slide ${index + 1}`}
                      className="img-fluid w-100 rounded-4"
                      style={{ maxHeight: "500px", objectFit: "cover" }}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </section>

          <div className="container my-5">
            <div
              className="card border-0 shadow-lg rounded-4 overflow-hidden"
              style={{ maxWidth: "420px", margin: "auto" }}
            >
              <img
                src={fullfacebotox}
                alt="Full Face Botox"
                className="card-img-top"
                style={{ height: "280px", objectFit: "cover" }}
              />
              <div className="card-body text-center px-4 py-4">
                <h5 className="card-title fw-bold text-uppercase text-dark mb-2">
                  Full Face Botox
                </h5>
                <p className="card-text text-muted small">
                  Smooth fine lines and wrinkles with Full Face Botox. Get a
                  youthful, refreshed, and natural appearance by relaxing facial
                  muscles.
                </p>
                <h6
                  className="text-success fw-bold mt-3"
                  style={{ fontSize: "1.1rem" }}
                >
                  Price: AED 199
                </h6>
                <button
                  className=" rounded-pill px-4 py-2 mt-3 text-white"
                  style={{
                    background: "#c69933",
                    border: "2px solid ",
                  }}
                  onClick={() => addToCart(product)}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          </div>

          {/* Why Choose Us Section */}
          <WhyUs />

          <Testimonials data={sectionsData["Success Stories"]} />
          <OurTeam data={sectionsData["Professional"]} />

        
          <ShareButtons />
        </div>

        <MultiStepForm />
      </div>
    </div>
  );
};

export default ServiceTemplate;
